import styled from 'styled-components';

export const Tag = styled.span`
    background-color: ${(props) => (props.color ? props.color : '#393837')};
    border-radius: 5px;
    position: relative !important;
    display: inline !important;
    flex-direction: row !important;
    cursor: pointer !important;
    line-height: 30px !important;
    border-radius: 4px !important;
    padding: 3px 20px 3px 4px !important;
    color: white;
    
}
`;

export const Text = styled.span`
    color: white;
    font-weight: 500;
    padding-right: 5px;
}
`;

export const EntityLabel = styled.span`
    color: white;
    font-size: 8px;
    font-weight: 400;
    padding-right: 5px;
}
`;

export const DeleteButton = styled.span`
    line-height: 23px !important;
    font-style: inherit;
    text-align: center;
    position: absolute !important;
    bottom: 0px !important;
    opacity: 0.6 !important;
    background-color: rgba(0, 0, 0, 0.1) !important;
    font-weight: 500;
    z-index: 500;
    width: 20px
}
`;
